import * as React from "react";
import * as yup from "yup";
import { Form, Table, Modal, Button, Segment, Message, ModalHeader, ModalContent, ModalActions, TableBody, TableRow, TableCell } from "@/components/bp/bp-ui";
import { ClientResources, LabClient, DropInDataViewModel } from "@app/api2/api";
import { Formik } from "formik";
import SemanticField from "../../SemanticField";
import { FileUpload, IUploadedFile } from "../FileUpload";
import { areYouSure } from "../AreYouSure";
import { TranslationContext } from "../Contexts/TranslationContext";
import { BPButton } from "@/components/bp/bpbutton";

export interface LabDropInDataViewProps {
    readOnly: boolean;
    labId: number;
}

export class LabDropInDataView extends React.Component<LabDropInDataViewProps, { dropInData: DropInDataViewModel; dialogOpen: boolean; }> {
    labClient = new LabClient();

    validationSchema: yup.AnyObjectSchema;

    constructor(props, context) {
        super(props, context);

        this.validationSchema = yup.object().shape({
            file: yup.object().shape({
                fileName: yup.string().required().nullable(false)
            }).required().nullable(false).typeError(window.translation.lab.pleaseSelectFile).label(window.translation.lab.dropInData),
        });

        this.state = {
            dialogOpen: false, dropInData: { totalNumberOfSystems: 0, peaks: [] }
        };
    }

    async componentDidMount() {
        let result = await this.labClient.getLabDropInData(this.props.labId);
        this.setState({
            dropInData: result
        });
    }

    async uploadDropInFile(file: IUploadedFile) {
        let res = await this.labClient.uploadLabDropInData(this.props.labId, file);
        this.componentDidMount();
    }

    @areYouSure(() => { return { message: window.translation.lab.deleteDropInConfirm, title: window.translation.common.confirmDelete }; })
    async deleteDropInFile() {
        let res = await this.labClient.deleteLabDropInData(this.props.labId);
        this.componentDidMount();
    }

    showUploadDialog() {
        this.setState({ dialogOpen: true });
    }


    setOpen(value: boolean) {
        this.setState({ dialogOpen: value });
    }

    render() {

        return (<TranslationContext.Consumer>{t => <>
            {this.state.dropInData == null &&
                <BPButton onClick={() => this.showUploadDialog()}>{t.lab.uploadDropInDataFile}</BPButton>
            }
            {this.state.dropInData != null &&
                <>
                    <BPButton negative onClick={() => this.deleteDropInFile()}>{t.common.delete}</BPButton>
                </>
            }
            <Modal open={this.state.dialogOpen} onClose={() => this.setOpen(false)} onOpen={() => this.setOpen(true)}>
                <ModalHeader>{t.lab.uploadDropInDataFile}</ModalHeader>
                <ModalContent>
                    <Formik initialValues={{ file: null as IUploadedFile }}
                        validationSchema={this.validationSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            //console.log(values);
                            await this.uploadDropInFile(values.file);

                            setSubmitting(false);
                            this.setOpen(false);
                        }}>
                        {({ isSubmitting, handleSubmit, values, setFieldValue, setFieldTouched, errors, touched }) => {
                            var errorList = Object.getOwnPropertyNames(errors)
                                .filter((k) => touched[k])
                                .map((k) => errors[k]);

                            return (
                                <Form id="form" onSubmit={handleSubmit}>
                                    <SemanticField component={FileUpload} name="file" label={t.lab.name} placeholderText={t.lab.dropInDataFile} value={values.file} error={errors.file && touched.file} fileUploaded={async (name: string, file: IUploadedFile) => { await setFieldValue("file", file ? file : null); }} />
                                    <Message error header={t.common.errorsOnForm} list={errorList} visible={errorList.length > 0} />


                                </Form>
                            )
                        }}
                    </Formik>
                </ModalContent>
                <ModalActions>
                    <BPButton form="form" type="submit">
                        {t.common.save}
                    </BPButton>
                    <BPButton onClick={() => this.setOpen(false)}>
                        {t.common.cancel}
                    </BPButton>
                </ModalActions>
            </Modal>
            {this.state.dropInData && this.state.dropInData.peaks.length > 0 &&
                <Table definition>
                    <TableBody>
                        <TableRow>
                            <TableCell>{t.lab.dropInPeakCount}</TableCell>
                            <TableCell>{this.state.dropInData.peaks.length}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{t.lab.dropInTotalNumberOfSystems}</TableCell>
                            <TableCell>{this.state.dropInData.totalNumberOfSystems}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>}
            {(this.state.dropInData == null || this.state.dropInData.peaks.length == 0) &&
                <Segment>
                    {t.lab.noDropInData}
                </Segment>}

        </>}</TranslationContext.Consumer>
        );
    }
}
